import React from 'react';
import { SimpleForm, Edit, TextInput, BooleanInput } from 'react-admin';
import { required } from 'ra-core';
import { NameTitle } from '../../utils/Title.component';
import ScreenDescription from '../ScreenDescription';
import SaveOnlyToolbar from '../SaveOnlyToolbar';

const BlockEdit = props => (
  <>
    <ScreenDescription>
      "Chave" é só um identificador interno estável — não muda o que já está classificado. Desativar não apaga nada, só some das
      opções de reclassificação daqui pra frente. Não existe exclusão de bloco — só desativação.
    </ScreenDescription>
    <Edit {...props} title={<NameTitle model="Bloco" record={props} />}>
      <SimpleForm toolbar={<SaveOnlyToolbar />}>
        <TextInput source="name" label="Nome" validate={required()} />
        <TextInput source="key" label="Chave" validate={required()} />
        <BooleanInput source="active" label="Ativo" />
      </SimpleForm>
    </Edit>
  </>
);

export default BlockEdit;
